type ReminderActionMeta = {
  label: string;
  href: string;
};

const REMINDER_LINKS: Record<string, ReminderActionMeta> = {
  gp: {
    label: 'Open NHS appointments guidance',
    href: 'https://www.nhs.uk/nhs-services/gps/',
  },
  dentist: {
    label: 'Find an NHS dentist',
    href: 'https://www.nhs.uk/nhs-services/dentists/how-to-find-an-nhs-dentist/',
  },
  optician: {
    label: 'Open NHS sight test guidance',
    href: 'https://www.nhs.uk/nhs-services/opticians/',
  },
  smear: {
    label: 'Open cervical screening guidance',
    href: 'https://www.nhs.uk/conditions/cervical-screening/',
  },
  mammogram: {
    label: 'Open breast screening guidance',
    href: 'https://www.nhs.uk/conditions/breast-screening-mammogram/',
  },
  'health-check': {
    label: 'Open NHS Health Check guidance',
    href: 'https://www.nhs.uk/tests-and-treatments/nhs-health-check/',
  },
  prostate: {
    label: 'Open PSA test guidance',
    href: 'https://www.nhs.uk/conditions/prostate-cancer/psa-testing/',
  },
  'hrt-review': {
    label: 'Open NHS HRT guidance',
    href: 'https://www.nhs.uk/medicines/hormone-replacement-therapy-hrt/',
  },
  'blood-test': {
    label: 'Open blood test guidance',
    href: 'https://www.nhs.uk/conditions/blood-tests/',
  },
  medication: {
    label: 'Open repeat prescription guidance',
    href: 'https://www.nhs.uk/nhs-services/prescriptions/how-to-order-a-repeat-prescription/',
  },
  vaccination: {
    label: 'Open NHS vaccinations guidance',
    href: 'https://www.nhs.uk/vaccinations/',
  },
};

export function getNhsReminderAction(type: string): ReminderActionMeta | null {
  return REMINDER_LINKS[type] || null;
}

export function getNhsRepeatPrescriptionAction(): ReminderActionMeta {
  return REMINDER_LINKS.medication;
}
